/**
 * AdminPanel.jsx — Panel principal de administración Elite Vacances
 * Colócalo en: src/components/AdminPanel.jsx
 *
 * Rutas:
 *   /admin              → este panel
 *   /admin-banner       → BannerAdmin
 *   /admin-tyc          → TyCAdmin
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/AdminPanel.css";

const MENUS = [
  {
    key: "banner",
    title: "Banner Principal",
    desc: "Edita los slides, destinos, hoteles y precios que se muestran en el banner de la página de inicio.",
    route: "/8c4f9d17b6e245dca9814f7a5b6d3e2f/admin-banner",
    badge: "Activo",
    badgeType: "",
    icon: (
      <svg viewBox="0 0 64 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="4" width="56" height="36" rx="5" fill="#0c3249"/>
        <rect x="6" y="8" width="48" height="28" rx="3" fill="#1a5276"/>
        <rect x="8" y="10" width="44" height="24" rx="2" fill="#a38d4e" opacity=".15"/>
        <polyline points="8,30 18,18 26,24 36,13 52,30" stroke="#a38d4e" strokeWidth="2.2" fill="none" strokeLinejoin="round"/>
        <circle cx="36" cy="13" r="3.5" fill="#a38d4e"/>
        <rect x="24" y="40" width="12" height="3" rx="1.5" fill="#0c3249"/>
        <rect x="18" y="43" width="24" height="2" rx="1" fill="#0c3249"/>
        <circle cx="52" cy="10" r="7.5" fill="#a38d4e"/>
        <line x1="52" y1="13.5" x2="52" y2="7" stroke="#fff" strokeWidth="1.8" strokeLinecap="round"/>
        <polyline points="49,10 52,6.5 55,10" stroke="#fff" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    key: "tyc",
    title: "Términos y Condiciones",
    desc: "Administra las promociones con sus términos y condiciones. Agrega, edita o elimina cada promoción.",
    route: "/8c4f9d17b6e245dca9814f7a5b6d3e2f/admin-tyc",
    badge: "Activo",
    badgeType: "",
    icon: (
      <svg viewBox="0 0 64 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="8" y="2" width="40" height="44" rx="4" fill="#0c3249"/>
        <rect x="12" y="6" width="32" height="36" rx="2" fill="#1a5276"/>
        <rect x="16" y="12" width="24" height="2.5" rx="1.25" fill="#a38d4e" opacity=".9"/>
        <rect x="16" y="18" width="20" height="2" rx="1" fill="#fff" opacity=".45"/>
        <rect x="16" y="23" width="22" height="2" rx="1" fill="#fff" opacity=".35"/>
        <rect x="16" y="28" width="16" height="2" rx="1" fill="#fff" opacity=".25"/>
        <circle cx="52" cy="38" r="10" fill="#a38d4e"/>
        <polyline points="47,38 50.5,41.5 57,35" stroke="#fff" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    key: "analytics",
    title: "Estadísticas de Promociones",
    desc: "Consulta en tiempo real los clicks en banners, botones y promociones del sitio.",
    route: "/8c4f9d17b6e245dca9814f7a5b6d3e2f/admin-analytics",
    badge: "Activo",
    badgeType: "",
    icon: (
      <svg viewBox="0 0 64 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="6" y="8" width="52" height="36" rx="5" fill="#0c3249"/>
        <rect x="14" y="28" width="8" height="12" rx="2" fill="#a38d4e"/>
        <rect x="28" y="20" width="8" height="20" rx="2" fill="#a38d4e" opacity=".85"/>
        <rect x="42" y="14" width="8" height="26" rx="2" fill="#a38d4e" opacity=".7"/>
        <polyline points="14,18 24,14 34,16 44,10 50,12" stroke="#fff" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" opacity=".6"/>
        <circle cx="50" cy="12" r="3" fill="#fff" opacity=".8"/>
      </svg>
    ),
  },
  {
    key: "testimonios",
    title: "Testimonios",
    desc: "Agrega, edita o elimina los testimonios que se muestran a los visitantes del sitio.",
    route: "/8c4f9d17b6e245dca9814f7a5b6d3e2f/admin-testimonios",
    badge: "Próximo",
    badgeType: "soon",
    icon: (
      <svg viewBox="0 0 64 48" fill="none" xmlns="">
        <rect x="4" y="4" width="42" height="30" rx="5" fill="#0c3249"/>
        <path d="M10 34 L6 44 L22 37" fill="#0c3249"/>
        <rect x="10" y="12" width="30" height="2.5" rx="1.25" fill="#a38d4e" opacity=".8"/>
        <rect x="10" y="19" width="22" height="2" rx="1" fill="#fff" opacity=".4"/>
        <polygon points="54,6 56,13 63,13 57.5,17.5 59.5,24.5 54,20 48.5,24.5 50.5,17.5 45,13 52,13" fill="#a38d4e" opacity=".85"/>
      </svg>
    ),
  },
];

export default function AdminPanel() {
  const navigate = useNavigate();

  return (
    <div className="ap-wrap">
      <div className="ap-shell">
        <header className="ap-topbar">
          <div className="ap-topbar__brand">
            <span className="ap-topbar__icon" aria-hidden="true">◆</span>
            <div>
              <h1 className="ap-topbar__title">Panel de Administración</h1>
              <p className="ap-topbar__sub">Elite Vacances · Gestión interna</p>
            </div>
          </div>
          <span className="ap-topbar__version">v3.0</span>
        </header>

        <div className="ap-body">
          <p className="ap-section-label">Módulos disponibles</p>

          <div className="ap-grid">
            {MENUS.map((m) => (
              <button
                key={m.key}
                className={`ap-card${m.badgeType ? ` ap-card--${m.badgeType}` : ""}`}
                onClick={() => navigate(m.route)}
              >
                {m.badge && (
                  <span className={`ap-card__badge${m.badgeType ? ` ap-card__badge--${m.badgeType}` : ""}`}>
                    {m.badge}
                  </span>
                )}
                <div className="ap-card__icon">{m.icon}</div>
                <h2 className="ap-card__title">{m.title}</h2>
                <p className="ap-card__desc">{m.desc}</p>
                <span className="ap-card__cta">Ir al módulo →</span>
              </button>
            ))}
          </div>

          <div className="ap-footer">
            <span>Elite Vacances SAS — Panel interno</span>
            <span><strong>v3.0</strong> React</span>
          </div>
        </div>
      </div>
    </div>
  );
}